import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl, ValidationErrors } from '@angular/forms';
import { ActivatedRoute, Router } from "@angular/router";
import { loadingFade } from '../../animacoes';

import { AuthService } from '../services/auth.service';
import { ProfissionalService } from '../services/profissional.service';
import { ProfissionalUnidadeService } from '../services/profissional-unidade.service';
import { TipoProfissionalService } from '../services/tipo-profissional.service';
import { UnidadeService } from '../services/unidade.service';
import { CursosService } from '../services/cursos.service';
import * as Datepicker from 'js-datepicker';
import * as moment from 'moment';
import Swal from 'sweetalert2';

@Component({
	selector: 'app-profissionais-edit',
	templateUrl: './profissionais-edit.component.html',
	styleUrls: ['./profissionais-edit.component.css'],
	animations: [loadingFade]
})
export class ProfissionaisEditComponent implements OnInit {

	public loading;
	public submitting = false;
	public profissional_id = null;
	public tipos_profissional = [];
	public unidades = [];
	public profissional_unidades = [];
	public profissional_cursos = [];
	public cursos = [];

	public tipo_cnh = [
		{ 'profissional_tipo_cnh': 'A'  },
		{ 'profissional_tipo_cnh': 'B'  },
		{ 'profissional_tipo_cnh': 'C'  },
		{ 'profissional_tipo_cnh': 'D'  },
		{ 'profissional_tipo_cnh': 'E'  },
		{ 'profissional_tipo_cnh': 'AB' },
		{ 'profissional_tipo_cnh': 'AC' },
		{ 'profissional_tipo_cnh': 'AD' },
		{ 'profissional_tipo_cnh': 'AE' }
	]

	public formProfissional: FormGroup;

	// datepickers
	public data_nascimento_dp;
	public data_vencimento_cnh_dp;
	public data_vencimento_curso_dp;
	public data_curso_dp;

	//filtro
	public cliente_id___cliente = null;
	public unidade_id___unidade = null;
	public profissional_nome___nome = null;
	public tipo_profissional_id___tipo = null; 
	public profissional_situacao___situacao = null;

	constructor(private authSvc: AuthService,
		private route: ActivatedRoute,
		private fb: FormBuilder,
		private router: Router,
		private profissionalSvc: ProfissionalService,
		private profissionalUnidadeSvc: ProfissionalUnidadeService,
		private tipoProfissionalSvc: TipoProfissionalService,
		private cursosSvc: CursosService,
		private unidadeSvc: UnidadeService) { }

	ngOnInit() {
		this.pegaTipoProfissional();
		this.pegaUnidades();
		this.pegaCursos();
		this.criaForm();
		this.route.params.subscribe(params => {
			if (params.id) {


				var splitFiltro = params.id.split("?");

				if(splitFiltro[1] !== undefined){
				  
				  var splitfiltro = splitFiltro[1].split("&");
				  for (let f in splitfiltro) {
		
					var loSplitValor = splitfiltro[f].split("=");
		
					switch(loSplitValor[0]) { 
					  case "cliente_id___cliente": { 
						 this.cliente_id___cliente = loSplitValor[1];
						 break; 
					  } 
					  case "unidade_id___unidade": { 
						this.unidade_id___unidade = loSplitValor[1];
						 break; 
					  } 
					  case "profissional_nome___nome": { 
						this.profissional_nome___nome = loSplitValor[1];
						 break; 
					  }      
					  case "tipo_profissional_id___tipo": { 
						this.tipo_profissional_id___tipo = loSplitValor[1];
						 break; 
					  }     
					  case "profissional_situacao___situacao": { 
						this.profissional_situacao___situacao = loSplitValor[1];
						 break; 
					  }  					                                                         
				   }
		
				  }
		
		
				}  

				this.loading = true;
				this.profissional_id = params.id;
				// pega dados a partir do id
				this.profissionalSvc.getProfissional(params.id).then((data: any) => {
					this.profissionalUnidadeSvc.getProfissionalUnidades(params.id).then((dados: any[]) => {
						for (let unidade of dados) {
							this.profissional_unidades.push(unidade.unidade_id);
						}

						this.preencheForm({
							usuario_id: this.authSvc.getUsuarioId(),
							unidade_id: '',
							cliente_id: '',
							profissional_id: data.profissional_id,
							profissional_nome: data.profissional_nome,
							profissional_email: data.profissional_email,
							//profissional_data_nascimento: this.formataData(data.profissional_data_nascimento),
							profissional_data_nascimento: moment(data.profissional_data_nascimento, 'YYYY-MM-DD').format('DD/MM/YYYY'),
							tipo_profissional_id: data.tipo_profissional_id,
							profissional_rg: data.profissional_rg,
							profissional_cpf: data.profissional_cpf,
							profissional_telefone_residencial: data.profissional_telefone_residencial,
							profissional_telefone_celular: data.profissional_telefone_celular,
							profissional_situacao: data.profissional_situacao,
							profissional_cnh: data.profissional_cnh,
							//profissional_data_vencimento_cnh: this.formataData(data.profissional_data_vencimento_cnh),
							profissional_data_vencimento_cnh: moment(data.profissional_data_vencimento_cnh, 'YYYY-MM-DD').format('DD/MM/YYYY'),
							profissional_pontuacao_cnh: data.profissional_pontuacao_cnh,
							profissional_tipo_cnh: data.profissional_tipo_cnh,
							profissional_matricula: data.profissional_matricula,
							//profissional_data_curso: this.formataData(data.profissional_data_curso),
							profissional_data_curso: moment(data.profissional_data_curso, 'YYYY-MM-DD').format('DD/MM/YYYY'),
							unidades: this.profissional_unidades,
						});
						this.loading = false;
					}).catch((err) => {
						console.log(err);
					});
				});

			}
			else {
				this.addRow();
				this.loading = false;
			}
		});
	}

	criaForm() {
		this.formProfissional = this.fb.group({
			profissional_id: null,
			usuario_id: this.authSvc.getUsuarioId(),
			unidade_id: '',
			cliente_id: '',
			profissional_nome: ['', [Validators.required]],
			profissional_email: [''],
			profissional_data_nascimento: [moment().format('DD/MM/YYYY'), Validators.required],
			/*profissional_data_nascimento: [null, [
				Validators.required
				, this.isValidDate //Novo metodo para tratar data
			]],*/
			tipo_profissional_id: [null, [Validators.required]],
			profissional_rg: [''],
			profissional_cpf: [''],
			profissional_telefone_residencial: [''],
			profissional_telefone_celular: [''],
			profissional_situacao: [''],
			profissional_cnh: '',
			profissional_data_vencimento_cnh: [null, [this.isValidDate]],
			profissional_pontuacao_cnh: '',
			profissional_tipo_cnh: null,
			profissional_matricula: [''],
			unidades: [null, [Validators.required]],
			profissional_data_curso: [null, [this.isValidDate]],
			// cursos: this.fb.array([])
		});

		let campos_data = ['profissional_data_nascimento', 'profissional_data_vencimento_cnh', 'profissional_data_curso'];
		moment.locale('pt-Br');
		for (let campo of campos_data) {
			Datepicker('#' + campo, {
				customMonths: moment.months(),
				customDays: moment.weekdaysShort(),
				overlayPlaceholder: 'Preencha o ano',
				overlayButton: 'Enviar',
				formatter: (element, date) => {
					let formatted = moment(date).format('DD/MM/YYYY');
					this.formProfissional.controls[campo].setValue(formatted);
				}
			});
		}
	}

	preencheForm(dados) {
		this.formProfissional.setValue(dados);
	}

	pegaTipoProfissional() {
		this.tipoProfissionalSvc.getTiposProfissional().then((data: any) => {
			this.tipos_profissional = data;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	pegaUnidades() {
		this.loading = true;
		this.unidadeSvc.getUnidadesByUsuario(this.authSvc.getUsuarioId()).then((data: any) => {
			this.unidades = data;
			for (let index in this.unidades) {
				this.unidades[index].cliente_nome = this.unidades[index].cliente.cliente_nome;
			}
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		});
	}

	pegaCursos() {
		this.cursosSvc.getCursos().then((data: any) => {
			this.cursos = data;
		}).catch((err) => {
			console.log(err);
		});
	}

	invalid(nome) {
		let input = this.formProfissional.get(nome);
		return input.touched && input.invalid;
	}

	enviaProfissional() {
		if (this.formProfissional.valid) {
			this.submitting = true;

			let toSend = this.formProfissional.value;

			//console.log("[toSend] - 1",  toSend);
			//if (toSend.profissional_data_nascimento)
			//	toSend.profissional_data_nascimento = moment(toSend.profissional_data_nascimento, 'DD/MM/YYYY').format('YYYY-MM-DD');	
			//	
			//if (toSend.profissional_data_vencimento_cnh)
			//	toSend.profissional_data_vencimento_cnh = moment(toSend.profissional_data_vencimento_cnh, 'DD/MM/YYYY').format('YYYY-MM-DD');

			if (this.profissional_id === null) { // criar
				this.profissionalSvc.criaProfissional(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Profissional cadastrado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/profissionais']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
			else { // editar
				this.profissionalSvc.editaProfissional(toSend).then((data) => {
					console.log('resp', data);
					Swal.fire({
						type: 'success',
						title: 'Profissional alterado com sucesso!',
						onClose: () => {
							this.router.navigate(['home/profissionais']);
						}
					});
				}).catch(err => {
					console.log(err);
					this.submitting = false;
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Tente novamente mais tarde.'
					});
				});
			}
		}
		else {
			for (let field in this.formProfissional.controls) {
				let campo = this.formProfissional.get(field);
				campo.markAsTouched();
			}
			this.submitting = false;
			Swal.fire({
				type: 'error',
				title: 'Atenção!',
				text: 'Verifique os campos obrigatórios e tente novamente.'
			});
		}
	}

	formataData(data) {
		if (moment(data, 'YYYY-MM-DD').isValid()) {
			return moment(data, 'YYYY-MM-DD').format('DD/MM/YYYY');
		}
		else {
			return null;
		}
	}


	createItemCurso(curso_id = null) {
		// moment.locale('pt-Br');
		// Datepicker('#datacurso', {
		// 	customMonths: moment.months(),
		// 	customDays: moment.weekdaysShort(),
		// 	overlayPlaceholder: 'Preencha o ano',
		// 	overlayButton: 'Enviar',
		// 	formatter: (element, date) => {
		// 		let formatted = moment(date).format('DD/MM/YYYY');
		// 		this.formProfissional.controls['#datacurso'].setValue(formatted);
		// 	}
		// });
		return this.fb.group({
			curso_id: [curso_id],
		})
		

	}

	onChangeEquipe(e) {
		if (e != null) {
			const equipes = this.formProfissional.get('profissionais') as FormArray;
			for (let i = equipes.controls.length; i >= 0; i--) {
				equipes.removeAt(i);
			}

			for (let profissional of e.profissionais) {
				equipes.push(this.createItemCurso());
			}
		}
	}

	addRow(curso_id = null){
		const cursos = this.formProfissional.get('cursos') as FormArray;
		cursos.push(this.createItemCurso(curso_id));
	}

	removeRow(index){
		const cursos = this.formProfissional.get('cursos') as FormArray;
		cursos.controls.length == 1 || cursos.removeAt(index);
	}

	isValidDate(c: FormControl): ValidationErrors {
		let result: ValidationErrors = null;
		const isValid = moment(c.value, 'DD/MM/YYYY').isValid();
		if (!isValid) {
			result = { invalidDate: 'Invalid date' };
		}
		return result;
	  }

	
	
	  onClickVoltar(){

		let params = 'cliente_id___cliente=' + this.cliente_id___cliente;
		params += "&unidade_id___unidade=" + this.unidade_id___unidade;
		params += "&profissional_nome___nome=" + this.profissional_nome___nome;
		params += "&tipo_profissional_id___tipo=" + this.tipo_profissional_id___tipo;
		params += "&profissional_situacao___situacao=" + this.profissional_situacao___situacao;		
	
		//profissionais
		this.router.navigate(['/home/profissionaisfiltro/' + params]);
	
	  }	  
}
